import * as actions from "./actions";
import instance from "../axios";
import { setLoadingSuccess } from "services/loading/actions";
import ChromeCast from "services/chromecast";

export const getQuizData = (id: number) => {
  ChromeCast.quit();
  return (dispatch: any) => {
    return instance
      .get(`v1/quiz/${id}?timestamp=${new Date().getTime()}`)
      .then((res) => {
        //console.log(res.data);
        dispatch(actions.setQuiz(res.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const syncQuizConfig = (id: number) => {
  return (dispatch: any) => {
    return instance
      .get(`v1/quiz/${id}?timestamp=${new Date().getTime()}`)
      .then((res) => {
        dispatch(actions.syncQuizConfig(res.data));
        return res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const nextPage = () => {
  return (dispatch: any) => {
    dispatch(actions.nextPage());
  };
};

export const prevPage = () => {
  return (dispatch: any) => {
    dispatch(actions.prevPage());
  };
};

export const setProgress = (position: any) => {
  return (dispatch: any) => {
    dispatch(actions.setProgress(position));
  };
};
export const updateProgress = (position: any) => {
  return (dispatch: any) => {
    dispatch(actions.updateProgress(position));
  };
};

export const loadQuiz = () => {
  return (dispatch: any) => {
    dispatch(actions.loadQuiz());
  };
};

export const resetQuizData = () => {
  return (dispatch: any) => {
    dispatch(actions.resetQuizData());
  };
};

export const resetStore = () => {
  return (dispatch: any) => {
    dispatch(actions.resetStore());
  };
};

export const submitResults = (results: any, quizConfig: any, user: any) => {
  results.forEach((team: any) => {
    team.email = team.teamEmail;
    team.rounds.forEach((round: any, i: any) => {
      if (round === null) {
        team.rounds[i] = Array(quizConfig.format.questionCount).fill(0);
      }
    });
  });

  let questionIdArray = quizConfig.rounds.map(
    (round: any) => round.questionIds
  );
  if (quizConfig.format.isCrossword) {
    let cwQuestionIdArray = quizConfig.puzzle.crosswordQuestions.map(
      (round: any) => round.questionId
    );
    questionIdArray.push(cwQuestionIdArray);
  }
  let data = {
    quizName: quizConfig.quizName,
    results,
    customerId: user.userDetails.customerId,
    questionIds: questionIdArray,
  };

  //console.log(data);

  return (dispatch: any) => {
    dispatch(actions.resultsSubmittedSuccess());
    dispatch(setLoadingSuccess({ loading: true, message: "Finalising quiz" }));
    return instance
      .post(`v1/results/submit/`, data)
      .then((res) => {
        dispatch(actions.resultsSubmittedSuccess());
        dispatch(setLoadingSuccess({ loading: false, message: "" }));
        return res;
        // dispatch(actions.resultsSubmittedFailed());
        // dispatch(setLoadingSuccess({ loading: false, message: "" }));
        // return { status: 500 };
      })
      .catch((err) => {
        dispatch(actions.resultsSubmittedFailed());
        console.log(err);
        dispatch(setLoadingSuccess({ loading: false, message: "" }));
        return false;
      });
  };
};
